import { UiVaultConfig } from '../../../../../@types/vaults';
import { getVaultContactIconFromUrl } from '../v1Components';
import { VaultOverviewSectionBox } from '../VaultOverviewSectionBox';

const VaultOverviewContactsBox = (props: {
	contacts: UiVaultConfig['vaultSidePanelContactInformation'];
}) => {
	if (!props.contacts) return null;

	return (
		<VaultOverviewSectionBox>
			<span className="typo-t3 text-text-default">Contact</span>
			<div className="flex flex-col gap-4">
				{props.contacts.map((contact) => {
					const Icon = getVaultContactIconFromUrl(contact.link);

					return (
						<span
							key={contact.name}
							className="flex items-center gap-1 typo-t4"
						>
							{Icon && <Icon className="h-5 w-5" />}
							<a
								target="_blank"
								href={contact.link}
								rel="noopener noreferrer"
								className="text-text-secondary"
							>
								{contact.name}
							</a>
						</span>
					);
				})}
			</div>
		</VaultOverviewSectionBox>
	);
};

export default VaultOverviewContactsBox;
